<template>
  <div id="content" style="height: 100vh">
    <NavbarNotLoggedIn />
    <NotificationGroup group="danger">
      <div
        class="fixed inset-0 flex items-start justify-end px-4 py-6 mt-[85vh] pointer-events-none"
      >
        <div class="w-full max-w-sm">
          <Notification
            v-slot="{ notifications }"
            enter="transform ease-out duration-300 transition"
            enter-from="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-4"
            enter-to="translate-y-0 opacity-100 sm:translate-x-0"
            leave="transition ease-in duration-500"
            leave-from="opacity-100"
            leave-to="opacity-0"
            move="transition duration-500"
            move-delay="delay-300"
          >
            <div
              class="flex w-full max-w-sm mx-auto mt-4 overflow-hidden bg-white rounded-lg shadow-md"
              v-for="notification in notifications"
              :key="notification.id"
            >
              <div class="flex items-center justify-center w-12 bg-darkAccent">
                <svg
                  class="w-6 h-6 text-white fill-current"
                  viewBox="0 0 40 40"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M20 3.33331C10.8 3.33331 3.33337 10.8 3.33337 20C3.33337 29.2 10.8 36.6666 20 36.6666C29.2 36.6666 36.6667 29.2 36.6667 20C36.6667 10.8 29.2 3.33331 20 3.33331ZM16.6667 28.3333L8.33337 20L10.6834 17.65L16.6667 23.6166L29.3167 10.9666L31.6667 13.3333L16.6667 28.3333Z"
                  />
                </svg>
              </div>

              <div class="px-4 py-2 -mx-3">
                <div class="mx-3">
                  <span class="font-semibold text-black">{{
                    notification.title
                  }}</span>
                  <p class="text-sm text-gray-600">{{ notification.text }}</p>
                </div>
              </div>
            </div>
          </Notification>
        </div>
      </div>
    </NotificationGroup>

    <div class="">
      <div class="">
        <div class="grid place-items-center h-[70vh]">
          <div class="w-[400px] rounded overflow-hidden shadow-lg">
            <div class="px-6 py-4">
              <div
                class="font-bold text-xl mb-2 border-1"
                style="border-bottom: 1px solid black"
              >
                Sign in
              </div>
              <!-- <p class="text-gray-700 text-base">
                      Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptatibus quia, nulla! Maiores et perferendis eaque, exercitationem praesentium nihil.
                    </p> -->

              <br />

              <!-- <input v-model="username" type="text" class="input mb-3 mt-4 mr-2" style="width:200px;" placeholder="username" required>

                  <input v-model="password" type="password" class="md:flex appearance-none border-2 border-gray-400 rounded  py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-gray-100 focus:border-gray-900" style="width:200px;" placeholder="Password" required> -->
              <div class="md:flex md:items-center my-6">
                <div class="md:w-[120px] ml-[15px]">
                  <label
                    class="block text-gray-500 font-bold md:text-right pr-4"
                    for="inline-full-name"
                  >
                    Email:
                  </label>
                </div>
                <div class="md:w-[300px]">
                  <input
                    v-model="username"
                    class="md:flex appearance-none border-2 border-gray-400 rounded py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:ring-0 focus:bg-gray-100 focus:border-orange-700 w-[200px]"
                    type="email"
                    placeholder="Email"
                  />
                </div>
              </div>
              <div class="md:flex md:items-center mt-6">
                <div class="md:w-[100px] ml-[19px]">
                  <label
                    class="block text-gray-500 font-bold md:text-right pr-4"
                    for="inline-full-name"
                  >
                    Password:
                  </label>
                </div>
                <div class="md:w-[300px]">
                    <div class="relative w-[200px]">
                      <input
                        v-model="password"
                        class="md:flex appearance-none border-2 border-gray-400 rounded py-2 px-4 pr-10 text-gray-700 leading-tight focus:outline-none focus:ring-0 focus:bg-gray-100 focus:border-orange-700 w-full"
                        :type="showPassword ? 'text' : 'password'"
                        placeholder="password"
                      />
                      <button
                        type="button"
                        @click="showPassword = !showPassword"
                        class="absolute inset-y-0 right-0 flex items-center px-3 text-gray-500 hover:text-black"
                        aria-label="Toggle password visibility"
                      >
                        <i :class="showPassword ? 'fa-solid fa-eye-slash' : 'fa-solid fa-eye'"></i>
                      </button>
                    </div>
                </div>
              </div>
              <br />
              <button
                class="bg-buttonAccent1 hover:bg-buttonAccentHover w-[270px] text-white font-bold py-2 mx-1 rounded disabled:opacity-60 disabled:cursor-not-allowed"
                type="submit"
                :disabled="loading"
                @click="submit"
              >
                {{ loading ? "Signing in..." : "Sign in" }}
              </button>

              <div class="text-center mt-4">
                <router-link
                  to="/forgot-password"
                  class="text-sm text-gray-500 hover:text-black hover:underline"
                >
                  Forgot password?
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../boot/axios";
import NavbarNotLoggedIn from "@/components/NavbarNotLoggedIn.vue";
import { notify } from "notiwind";
import { setCurrentUser } from "@/store/index.js";
import { setAuthSession } from "@/auth/permissions";

export default {
  name: "login",
  components: { NavbarNotLoggedIn },
  data() {
    return {
      username: "",
      password: "",
      loading: false,
      showPassword: false,
    };
  },
  methods: {
    async submit() {
      if (!this.username || !this.password) {
        this.toastDanger("Please enter email and password.");
        return;
      }

      const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(
        String(this.username).trim()
      );

      if (!isValidEmail) {
        this.toastDanger("Please enter a valid email address.");
        return;
      }

      this.loading = true;

      try {
        const res = await api.post("/auth/logins", {
          email: this.username,
          password: this.password,
        });

        if (res.status === 200 && res.data.status === true) {
          const data = res.data;

          // ── Save all auth data to localStorage ──────────────────
          // Backend returns: access_token, r_token, role, email,
          //                  name, id, permissions[], is_superadmin
          setAuthSession(data);
          setCurrentUser.value = data.name;

          // ── Set auth header for immediate next requests ──────────
          api.defaults.headers.common[
            "Authorization"
          ] = `Bearer ${data.access_token}`;

          this.$router.push({ name: "Home" });
        } else {
          // Backend responded but login failed (wrong credentials)
          this.toastDanger(
            res.data?.message || "Invalid email or password. Please try again."
          );
          this.password = "";
        }
      } catch (err) {
        // Network error or 401 from backend
        const message =
          err?.response?.data?.message ||
          "Invalid email or password. Please try again.";
        this.toastDanger(message);
        this.password = "";
      } finally {
        this.loading = false;
      }
    },

    toastDanger(text = "User Credentials Does Not Match") {
      notify(
        {
          group: "danger",
          title: "Login Failed",
          text: text,
        },
        3000
      );
    },
  },
};
</script>

<style scoped>
.card {
  margin: 60px auto;
  float: none; 

  padding: 40px;
}
</style>